import { InlineIcon } from "@iconify/react";
import PropTypes from "prop-types";
import { useContext } from "react";
import { createUseStyles } from "react-jss";
import { TranslationContext } from "../../contexts";
import styleVariables from "../../style_setup";

const languages = {
  "en-GB": "English",
  GR: "Ελληνικά",
};

const flags = {
  "en-GB": "twemoji:flag-for-united-kingdom",
  GR: "twemoji:flag-for-greece",
};

function normailizeLanguage(lang) {
  if (lang === "en") return "en-GB";
  if (lang === "el") return "GR";
  return lang;
}

const styles = createUseStyles({
  LanguageMenuDropDownButton: (props) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "medium",
    fontWeight: "500",
    color: props.textColor ?? "black",
    //  marginTop: ".4rem",
    transition: "transform 0.2s ease-in-out, color 0.2s ease-in-out",
    "&:hover, &:focus": {
      color: "#f2987a",
    },
  }),
  [`@media ${styleVariables.media.smallscreen}`]: {},
});
export const LanguageMenuDropDownButton = ({ textColor = "black" }) => {
  const classes = styles({ textColor });

  const { i18n } = useContext(TranslationContext);

  return (
    <div
      className={classes.LanguageMenuDropDownButton}
      data-testid="languageMenuDropDownButton"
    >
      <InlineIcon icon={flags[normailizeLanguage(i18n.language)] || flags["en-GB"]} width="20" height="25" />
    </div>
  );
};
LanguageMenuDropDownButton.propTypes = {
  textColor: PropTypes.string,
};
